export enum FeatureFlags {
  PROPERTY_COMMENTS = "propertyComments",
  PROPERTY_HISTORY = "propertyHistory",
  PROPERTY_REALTOR_DATA = "propertyRealtorData",
  PROPERTY_EDIT_ACTION = "propertyEditAction",
  PROPERTY_ARCHIVE_ACTION = "propertyArchiveAction",
  PROPERTIES_LIST_REALTOR_FILTERS = "propertiesListRealtorFilters",
  PROPERTIES_LIST_TABLE_VIEW = "propertiesListTableView",
  PROPERTY_OTHER_ACTIONS = "propertyOtherActions",
  PROPERTY_STATUS = "propertyStatus",
  PROPERTY_AGENT = "propertyAgent",
  // New feature flags
  SMART_AUTOCOMPLETE = "smartAutocomplete",
  ADD_OBJECT_LOCATION = "addObjectLocation",
  REALTOR_INFO_IN_ADDITIONAL_STEP = "realtorInfoInAdditionalStep",
}

export const FEATURE_FLAGS_COOKIE = "avezor_feature_flags";

export interface FeatureFlagConfig {
  category: string;
  description: string;
  defaultValue: boolean;
}

export const FEATURE_FLAG_CONFIGS: Record<FeatureFlags, FeatureFlagConfig> = {
  [FeatureFlags.PROPERTIES_LIST_TABLE_VIEW]: {
    category: "List",
    description: "Enable properties list table view",
    defaultValue: false,
  },
  [FeatureFlags.PROPERTIES_LIST_REALTOR_FILTERS]: {
    category: "List",
    description: "Enable realtor-specific filters in properties list",
    defaultValue: false,
  },
  [FeatureFlags.SMART_AUTOCOMPLETE]: {
    category: "Forms",
    description: "Enable smart autocomplete for location input",
    defaultValue: true,
  },
  [FeatureFlags.ADD_OBJECT_LOCATION]: {
    category: "AddObject",
    description: "Enable new location step in add object form",
    defaultValue: false,
  },
  [FeatureFlags.REALTOR_INFO_IN_ADDITIONAL_STEP]: {
    category: "AddObject",
    description:
      "Show realtor fields in AdditionalInfoStep for PRIMARY dealType",
    defaultValue: true,
  },
  [FeatureFlags.PROPERTY_COMMENTS]: {
    category: "Property",
    description: "Enable comments on property details page",
    defaultValue: false,
  },
  [FeatureFlags.PROPERTY_HISTORY]: {
    category: "Property",
    description: "Enable history tracking on property details page",
    defaultValue: false,
  },
  [FeatureFlags.PROPERTY_REALTOR_DATA]: {
    category: "Property",
    description: "Show realtor data on property details page",
    defaultValue: true,
  },
  [FeatureFlags.PROPERTY_EDIT_ACTION]: {
    category: "Property",
    description: "Enable edit action on property details page",
    defaultValue: true,
  },
  [FeatureFlags.PROPERTY_ARCHIVE_ACTION]: {
    category: "Property",
    description: "Enable archive action on property details page",
    defaultValue: true,
  },
  [FeatureFlags.PROPERTY_OTHER_ACTIONS]: {
    category: "Property",
    description:
      "Enable other actions (like share, print) on property details page",
    defaultValue: false,
  },
  [FeatureFlags.PROPERTY_STATUS]: {
    category: "Property",
    description:
      "Show property status (e.g., sold, pending) on property details page",
    defaultValue: true,
  },
  [FeatureFlags.PROPERTY_AGENT]: {
    category: "Property",
    description: "Show property agent information on property details page",
    defaultValue: false,
  },
};
